<template>
    <div id="offline-support-form" class="h-100" :key="$i18n.locale">
        <!-- Gonderildi -->
        <div v-if="successfulSent" class="osr-state">
            <span class="osr-state-icon is-success" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12.5l4.5 4.5L19 7.5" />
                </svg>
            </span>
            <h3 class="osr-state-title">{{ $t("message.createdTicketMsg") }}</h3>
            <p class="osr-state-text">{{ $t("message.messageSent") }}</p>
            <div class="osr-actions is-center">
                <button type="button" class="offline-btn offline-btn--primary" @click="reconnect">
                    {{ $t("message.startChatAgain") }}
                </button>
            </div>
        </div>

        <!-- Form -->
        <form v-else-if="formVisible" class="osr-form" autocomplete="off" novalidate @submit.prevent="submit">
                <div class="osr-field" :class="{ 'is-invalid': hasError($t('message.yourName')) }">
                    <label class="welcome-field-label" :for="'osr-fullname'">
                        {{ $t('message.yourName') }}<span class="welcome-field-required">*</span>
                    </label>
                    <div class="osr-box">
                        <input id="osr-fullname" class="osr-input" v-model="offlineForm.fullname" v-validate="'required'" :name="$t('message.yourName')" autocomplete="off" autofocus />
                    </div>
                    <span v-if="hasError($t('message.yourName'))" class="welcome-select-error">{{ errorFor($t('message.yourName')) }}</span>
                </div>
                <div class="osr-field" :class="{ 'is-invalid': hasError($t('message.email')) }">
                    <label class="welcome-field-label" :for="'osr-email'">
                        {{ $t('message.email') }}<span class="welcome-field-required">*</span>
                    </label>
                    <div class="osr-box">
                        <input id="osr-email" class="osr-input" v-model="offlineForm.email" v-validate="'required|email'" :name="$t('message.email')" autocomplete="off" type="email" inputmode="email" />
                    </div>
                    <span v-if="hasError($t('message.email'))" class="welcome-select-error">{{ errorFor($t('message.email')) }}</span>
                </div>
                <div class="osr-field" :class="{ 'is-invalid': hasError($t('message.phone')) }">
                    <label class="welcome-field-label" :for="'osr-phone'">
                        {{ $t('message.phone') }}<span class="welcome-field-required">*</span>
                    </label>
                    <div class="osr-box">
                        <input id="osr-phone" class="osr-input" v-model="offlineForm.phone" v-validate="'required'" :name="$t('message.phone')" autocomplete="off" type="tel" inputmode="tel" v-mask="'(###) ### ## ##'" />
                    </div>
                    <span v-if="hasError($t('message.phone'))" class="welcome-select-error">{{ errorFor($t('message.phone')) }}</span>
                </div>
                <div class="osr-field" :class="{ 'is-invalid': hasError($t('message.messageTextPlaceHolder')) }">
                    <label class="welcome-field-label" :for="'osr-message'">
                        {{ $t('message.messageTextPlaceHolder') }}<span class="welcome-field-required">*</span>
                    </label>
                    <div class="osr-box">
                        <textarea id="osr-message" class="osr-input osr-textarea" v-model="offlineForm.message" v-validate="'required'" :name="$t('message.messageTextPlaceHolder')" rows="4" :placeholder="$t('message.messageTextPlaceHolder')" />
                    </div>
                    <span v-if="hasError($t('message.messageTextPlaceHolder'))" class="welcome-select-error">{{ errorFor($t('message.messageTextPlaceHolder')) }}</span>
                </div>

            <!-- md-select menuyu <body>'ye tasiyordu; yerel select her yerde dogru aciliyor. -->
            <div class="osr-field">
                <label class="welcome-field-label" for="offline-return-type">
                    {{ $t("message.preferredResponseMethod") }}
                </label>
                <div class="welcome-select" :class="{ 'is-filled': !!offlineForm.returnType }">
                    <select
                        id="offline-return-type"
                        class="welcome-select-input"
                        v-model="offlineForm.returnType"
                        name="returnType"
                    >
                        <option value="email">{{ $t("message.responseViaEmail") }}</option>
                        <option value="whatsapp">{{ $t("message.responseViaWhatsapp") }}</option>
                    </select>
                    <span class="welcome-select-chevron" aria-hidden="true"></span>
                </div>
            </div>

            <div class="osr-actions">
                <button type="button" class="offline-btn offline-btn--ghost" :disabled="sending" @click="cancel">
                    {{ $t("message.cancel") }}
                </button>
                <button type="submit" class="offline-btn offline-btn--primary" :disabled="sending">
                    <span v-if="sending" class="osr-spinner" aria-hidden="true"></span>
                    {{ $t("message.sendMessage") }}
                </button>
            </div>
        </form>

        <!-- Cevrimdisi onayi -->
        <div v-else class="osr-state are-you-sure-ticket">
            <span class="osr-state-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a7 7 0 1 0 11 11z" />
                </svg>
            </span>
            <h3 class="osr-state-title" v-html="osrMessage.title"></h3>
            <p class="osr-state-text" v-html="osrMessage.content"></p>
            <div class="osr-actions is-center">
                <button type="button" class="offline-btn offline-btn--ghost" @click="cancel">
                    {{ $t("message.cancel") }}
                </button>
                <button type="button" class="offline-btn offline-btn--primary" @click="formVisible = true">
                    {{ $t("message.sendMessage") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { createOfflineSupportRequest } from "../../api/offlineSupportRequest";
import log2 from "../../utils/log2";
import _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";

import { sendMinimizeAction } from "../../utils/parentWindowConnection";

const log = log2("OfflineSupportRequestForm");
export default {
    name: "OfflineSupportRequestForm",
    props: {
        ticketMode: Boolean,
    },
    data() {
        return {
            sending: false,
            successfulSent: false,
            formVisible: false,
            offlineForm: {
                email: undefined,
                fullname: undefined,
                phone: "",
                message: undefined,
                returnType: "email", // Varsayılan değer olarak email'i seçiyoruz
            },
            baseUrl: () => {
                if (document.currentScript) {
                    let _documentUrl = document.currentScript.src.split("/");
                    return _documentUrl[0] + "//" + _documentUrl[2] + "/";
                } else {
                    return "/";
                }
            },
            headerTitle: this.$t("message.createTicket"),
        };
    },
    computed: {
        ...mapState({
            visitorId: (state) => state.chat.visitorId,
            site: (state) => state.site.site,
            language: (state) => state.language.language,
            settings: (state) => state.setting.settings,
            contents: (state) => _.get(state.setting.settings, "osrLabels.languageContent", []) || [],
            currentHostUrl: (state) => state.app.currentHostUrl,
            offlineMode: (state) => state.setting.offlineMode,
            //visitorPreferredLang: (state) => _.get(state.chat.visitorInfo, "preferredLang", "tr"),
        }),
        ...mapGetters({
            reconnecting: "chat/reconnecting",
        }),
        osrMessage() {
            const contents = _.get(this, "contents", []) || [];
            const maybeContent =
                contents.length > 0 &&
                contents.find((content) => content.languageCode === _.get(this.language, "code"));
            return maybeContent || { title: this.$t("message.offline"), content: this.$t("message.noRepresentative") };
        },
    },
    methods: {
        // Tetikleyiciden gelen mesaj mesaj alanina yazilir; ekran cevrimdisi karsilamasinda kalir,
        // ziyaretci "Mesaj gonder" deyince form dolu acilir. Form pencere acilirken zaten yuklu
        // olabilir; bu yuzden mounted disinda watcher'dan da cagrilir.
        applyPrefill() {
            const prefill = this.$store.state.app.offlineFormPrefill;
            if (!prefill) return;
            this.offlineForm.message = prefill;
            this.$store.commit("app/SET_OFFLINE_FORM_PREFILL", "");
        },
        ...mapActions({
            getSettings: "setting/getSettings",
            resetConversation: "chat/resetConversation",
            setVisitorIsLoggedIn: "chat/setVisitorIsLoggedIn",
            setVisitorIsLogging: "chat/setVisitorIsLogging",
        }),
        ...mapMutations({
            changePageIndex: "app/CHANGE_PAGE",
        }),
        hasError(field) {
            return this.errors.has(field);
        },
        errorFor(field) {
            return this.errors.first(field);
        },
        btnClickHandler(e) {},
        cancel() {
            if (!this.offlineMode) {
                this.$emit("change-to-ticket", false);
                this.changePageIndex(1);
                this.formVisible = false;
            } else {
                sendMinimizeAction();
            }
        },
        submit() {
            if (this.sending) return;
            this.$validator.validateAll().then((isSuccess) => {
                if (isSuccess) {
                    const payload = {
                        ...this.offlineForm,
                        phone: (this.offlineForm.phone || "")
                            .replaceAll("(", "")
                            .replaceAll(")", "")
                            .trim()
                            .replaceAll(" ", ""),
                        languageCode: this.language.code,
                        visitorId: this.visitorId,
                        returnType: this.offlineForm.returnType, // Yeni alanı payload'a ekliyoruz
                    };
                    log("osr submitting", payload);
                    this.sending = true;
                    this.$message.config({
                        top: "35px",
                    });
                    this.$message.loading({ content: this.$t("message.creatingTicketMsg"), key: "updatable" });
                    sendSocketMessage("visitor ticket-message", { ...payload, siteId: this.site._id });
                    createOfflineSupportRequest(payload).then((response) => {
                        log("osr was sent", this.successfulSent);
                        this.successfulSent = true;
                        this.sending = false;
                        this.$emit("change-to-ticket", false);
                        this.$message.success({
                            content: this.$t("message.createdTicketMsg"),
                            key: "updatable",
                            duration: 3,
                        });
                    });
                } else {
                    log("osr form is not valid", isSuccess);
                }
            });
        },
        reconnect() {
            this.successfulSent = false;
            this.formVisible = false;
            this.offlineForm.message = "";
            this.resetConversation();
            this.changePageIndex(1);
            this.setVisitorIsLoggedIn(false);
            this.setVisitorIsLogging(false);
        },
    },
    mounted() {
        if (this.ticketMode) {
            this.formVisible = true;
        }
        this.applyPrefill();
        this.$emit("updateTitle", this.headerTitle);
    },

    updated() {},
    watch: {
        "$store.state.app.offlineFormPrefill"(val) {
            if (val) this.applyPrefill();
        },
        ticketMode(ticketModeEnabled) {
            log("ticketMode updated", {
                ticketMode: this.ticketMode,
                ticketModeEnabled,
                formVisible: this.formVisible,
            });
            if (ticketModeEnabled === false && this.formVisible) {
                this.formVisible = false;
            }
            if (this.ticketMode && !this.formVisible) {
                this.formVisible = true;
            }
        },
    },
};
</script>

<style lang="scss">
/* Cevrimdisi talep formu: karsilama diyalogu ile ayni alan dili
   (ustte sabit etiket, dolgulu kutu, odakta marka cercevesi). */
#offline-support-form {
    padding: 8px 18px 20px;
    color: var(--form-input-text);
}

.osr-form {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.osr-field {
    display: flex;
    flex-direction: column;
}

/* Alanlar beyaz kutu + ince cerceve: gri dolgu mor zeminde kirli duruyordu. */
.osr-box,
#offline-support-form .welcome-select {
    position: relative;
    background-color: #fff;
    border: 1.5px solid rgba(15, 23, 42, 0.12);
    border-radius: var(--sps-radius-md, 12px);
    transition: border-color 160ms ease, box-shadow 160ms ease;

    &:hover {
        background-color: #fff;
        border-color: rgba(15, 23, 42, 0.22);
    }

    &:focus-within {
        background-color: #fff;
        border-color: var(--button-color);
        box-shadow: 0 0 0 3px color-mix(in srgb, var(--button-color) 16%, transparent);
    }
}

.osr-field.is-invalid .osr-box {
    border-color: var(--sps-error-text, #d92d20);
    background-color: rgba(229, 72, 77, 0.05);
}

.osr-input {
    display: block;
    width: 100%;
    min-height: 48px;
    margin: 0;
    padding: 0 14px;
    border: 0;
    border-radius: var(--sps-radius-md, 12px);
    background: transparent;
    color: var(--form-input-text);
    font-family: inherit;
    font-size: 15px;
    line-height: 1.3;
    outline: none;
    -webkit-text-fill-color: var(--form-input-text);

    &::placeholder {
        color: var(--form-input-label);
        opacity: 0.6;
        -webkit-text-fill-color: var(--form-input-label);
    }
}

.osr-textarea {
    min-height: 104px;
    padding: 12px 14px;
    resize: none;
    line-height: 1.45;
}

/* Onay ve sonuc ekranlari: ortalanmis ikon + baslik + aciklama + eylemler */
.osr-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60%;
    padding: 24px 6px;
    text-align: center;
    color: var(--form-input-text);

    .osr-state-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 64px;
        margin-bottom: 16px;
        border-radius: 50%;
        background: color-mix(in srgb, var(--button-color) 12%, transparent);
        color: var(--button-color);

        &.is-success {
            background: rgba(34, 160, 107, 0.12);
            color: #22a06b;
        }
    }

    .osr-state-title {
        margin: 0 0 6px;
        font-size: 17px;
        font-weight: 700;
        line-height: 1.3;
        color: inherit;

        p {
            margin: 0;
        }
    }

    .osr-state-text {
        margin: 0;
        max-width: 300px;
        font-size: 14px;
        line-height: 1.5;
        opacity: 0.7;

        p {
            margin: 0;
        }
    }
}

.osr-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    width: 100%;
    margin-top: 8px;

    &.is-center {
        justify-content: center;
        margin-top: 24px;
    }
}

.offline-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex: 0 1 auto;
    white-space: nowrap;
    min-height: 44px;
    padding: 0 20px;
    border-radius: var(--sps-radius-md, 12px);
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: box-shadow 0.16s ease, filter 0.16s ease, background-color 0.15s ease;

    &:hover:not(:disabled) {
        filter: brightness(1.04);
    }

    &:active:not(:disabled) {
        filter: brightness(0.96);
    }

    &:disabled {
        opacity: 0.55;
        cursor: default;
    }
}

.offline-btn--ghost {
    color: var(--form-input-text);
    background-color: transparent;
    border: 1.5px solid rgba(15, 23, 42, 0.14);

    &:hover:not(:disabled) {
        background-color: rgba(15, 23, 42, 0.04);
    }
}

.offline-btn--primary {
    color: var(--button-text-color, #ffffff);
    background-color: var(--button-color);
    border: 1.5px solid var(--button-color);

    &:hover:not(:disabled) {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.14);
    }
}

.osr-spinner {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid currentColor;
    border-right-color: transparent;
    animation: osr-spin 0.7s linear infinite;
}

@keyframes osr-spin {
    to {
        transform: rotate(360deg);
    }
}

// Koyu tema: sabit beyaz kutu acik yaziyi okunmaz yapiyordu; acik tema degismez.
:root[data-color-scheme="dark"] {
    .osr-box,
    #offline-support-form .welcome-select {
        &,
        &:hover,
        &:focus-within {
            background-color: var(--sps-surface-raised);
        }
        border-color: var(--sps-border);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/OfflineSupportRequestForm.vue